import { render, staticRenderFns } from "./clientsDocuments.vue?vue&type=template&id=c44118ec&"
import script from "./clientsDocuments.vue?vue&type=script&lang=js&"
export * from "./clientsDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports